// extracted by mini-css-extract-plugin
export var banner = "_2i-0";
export var icon = "_2i-1";
export var message = "_2i-2";